import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerView } from './container_view';
import { TableView } from './table_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const ParticipantStatusesPreview = ({ productMessages, messages, sortIndex }) => {
    var _a, _b, _c, _d, _e;
    if (!messages) {
        return null;
    }
    const columns = [
        {
            key: 'sytemId',
            label: (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.systemId) !== null && _a !== void 0 ? _a : 'System ID',
            render: (value) => _jsx("span", { style: { color: '#3B82F6' }, children: value }),
        },
        { key: 'email', label: (_b = productMessages === null || productMessages === void 0 ? void 0 : productMessages.email) !== null && _b !== void 0 ? _b : 'Email' },
        { key: 'participant_number', label: (_c = productMessages === null || productMessages === void 0 ? void 0 : productMessages.participant_number) !== null && _c !== void 0 ? _c : 'Participant Number' },
        { key: 'status', label: (_d = productMessages === null || productMessages === void 0 ? void 0 : productMessages.status) !== null && _d !== void 0 ? _d : 'Status' },
        { key: 'created', label: (_e = productMessages === null || productMessages === void 0 ? void 0 : productMessages.created) !== null && _e !== void 0 ? _e : 'Created' },
    ];
    const data = Object.keys(messages)
        .sort((a, b) => { var _a, _b; return ((_a = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[b]) !== null && _b !== void 0 ? _b : 0); })
        .map((message, index) => ({
        systemId: `00${index + 1}`,
        email: '-',
        participant_number: `P0000${index + 1}`,
        status: messages[message],
        created: '-',
    }));
    return [
        _jsx(ContainerView, { children: _jsx("div", { style: { padding: '2rem' }, children: _jsx(TableView, { data: data, columns: columns }) }) }, 'participant-statuses-root'),
    ];
};
//# sourceMappingURL=participant_statuses.preview.component.js.map